import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AuthService } from 'src/app/pages/auth/services/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class UserInfoService {
  private userInfoSubject = new BehaviorSubject<any>(
    JSON.parse(localStorage.getItem('userInfo') || '{}'),
  );
  userInfo$ = this.userInfoSubject.asObservable();

  constructor(private auth: AuthService) {}

  getUserInfo() {
    return JSON.parse(localStorage.getItem('userInfo') || '{}');
  }

  setUserInfo(userInfo: any) {
    localStorage.setItem('userInfo', JSON.stringify(userInfo));
    this.userInfoSubject.next(userInfo); // ✅ notify header and any other subscribers
  }

  getAccessToken(): string {
    return this.getUserInfo().accessToken;
  }

  setAccessToken(accessToken: string) {
    let userInfo = this.getUserInfo();
    userInfo.accessToken = accessToken;
    this.setUserInfo(userInfo);
  }

  getRefreshToken() {
    return this.getUserInfo().refreshToken;
  }

  getUserId(): string {
    return this.getUserInfo().userId;
  }

  getUserRole(): string {
    return this.getUserInfo().role;
  }

  getUsername(): string {
    return this.getUserInfo().name;
  }

  clearUserInfo() {
    localStorage.removeItem('userInfo');
    this.userInfoSubject.next(null);
  }

  logout() {
    this.clearUserInfo();
    window.location.href = '/';
  }

  isUserLoggedIn(): boolean {
    return !!this.getAccessToken() && !!this.getUserId();
  }

  refreshToken(): Observable<any> {
    const refreshToken = this.getRefreshToken();
    if (refreshToken) {
      const logoutRequest = { refreshToken: refreshToken };
      return this.auth.refreshAccessToken(logoutRequest);
    } else return new BehaviorSubject(null);
  }
}
